import React from "react";
import "./formBuilderPanelDivider.scss";

export function FormBuilderPanelDivider() {
  return <hr className="form-builder-panel-divider" />;
}